module.exports = __webpack_public_path__ + "img/uj_04.2feef381.jpg";